import { makeStyles } from '@material-ui/core';
const innerAssetRowStyle = makeStyles((theme) => ({
    root: {
        border: "1px solid rgba(224, 224, 224, 1)",
    },
    innerTable: {
        backgroundColor: "#e3e3e3"
    },
    appBar: {
        position: 'relative',
    },
    rightAlign: {
        'text-align': "right"
    },
    consoleTypeCell: {
        fontWeight: "bold",
    },
    '@media (min-width: 960px)': {
        mobileTd1: {
            display: "none",
        },
        mobileTd2: {
            display: "table-cell",
        },
        innerTd: {
            width: "30%",
            '&:first-child': {
                width: "10%"
            }
        },
        iconImage: {
            height: '1em',
            margin: "0.5em"
        },
    },
    '@media (max-width: 960px)': {
        mobileTd1: {
            display: "block",
        },
        mobileTd2: {
            display: "none",
        },
        innerTd: {
            width: "33%",
            padding: "0.5rem 0.5rem 0.5rem 0.5rem;"
        },
        iconImage: {
            height: '1em',
            margin: "0.2em"
        },
    },
    '@media (max-width: 480px)': {
        mobileTd1: {
            display: "block",
        },
        mobileTd2: {
            display: "none",
        },
        innerTd: {
            width: "33%",
            padding: "0.1rem 0.1rem 0.1rem 0.1rem;"
        },
        iconImage: {
            height: '0.5em',
            margin: "0.2em"
        },
    },
    customChip: {
        backgroundColor: theme.palette.primary.main
    }
}));

export default innerAssetRowStyle;